import { render, staticRenderFns } from "./TrainorderdetailsRight.vue?vue&type=template&id=1e9d9d0e&scoped=true"
import script from "./TrainorderdetailsRight.vue?vue&type=script&lang=js"
export * from "./TrainorderdetailsRight.vue?vue&type=script&lang=js"
import style0 from "./TrainorderdetailsRight.vue?vue&type=style&index=0&id=1e9d9d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9d9d0e",
  null
  
)

export default component.exports